import { Badge, Flex, Text } from "@radix-ui/themes";
import {
  createColumnHelper,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useMemo } from "react";
import type { SponsorsReportPage } from "@/types/sponsors_report";
import { formatCount, formatCtr } from "@/shared/sponsors/stats";
import BasicTable from "../BasicTable";

interface Props {
  pages: SponsorsReportPage[];
}

const columnHelper = createColumnHelper<SponsorsReportPage>();

export default function PagesTable({ pages }: Props) {
  const columns = useMemo(
    () => [
      columnHelper.accessor("label", {
        header: "Page",
        cell: (props) => (
          <Flex align="center" gap="2">
            <Badge color="gray" variant="soft" size="1">
              {props.row.original.kind}
            </Badge>
            <Text size="2">{props.getValue()}</Text>
          </Flex>
        ),
      }),
      columnHelper.accessor("impressions", {
        header: "Impressions",
        cell: (props) => <Text size="2">{formatCount(props.getValue())}</Text>,
      }),
      columnHelper.accessor("clicks", {
        header: "Clicks",
        cell: (props) => <Text size="2">{formatCount(props.getValue())}</Text>,
      }),
      columnHelper.accessor("ctr", {
        header: "CTR",
        cell: (props) => <Text size="2">{formatCtr(props.getValue())}</Text>,
        sortUndefined: "last",
      }),
    ],
    [],
  );

  const table = useReactTable({
    data: pages,
    columns,
    enableColumnFilters: false,
    initialState: { sorting: [{ id: "impressions", desc: true }] },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return <BasicTable table={table} />;
}
